import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "North Peak Facility Services";
const LOCATION = "Montreal, Quebec";
const BASE_KEYWORDS =
  "Cleaning Services Montreal, Commercial Cleaning Montreal, Residential Cleaning Montreal, Office Cleaning Montreal, Move Out Cleaning Montreal, Post Construction Cleaning Montreal, Facility Services Montreal, Cleaning Company Montreal";

export default function Seo({ title, description, keywords, path = "" }) {
  const fullTitle = title ? `${title} | ${SITE} — ${LOCATION}` : `${SITE} — Cleaning & Facility Services in ${LOCATION}`;
  const desc = description || `Professional cleaning and facility services in ${LOCATION}. Serving Montreal and the Greater Montreal Area for homes, offices, medical, retail, industrial and short-term rentals.`;
  const kw = keywords ? `${keywords}, ${BASE_KEYWORDS}` : BASE_KEYWORDS;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      <meta name="geo.region" content="CA-QC" />
      <meta name="geo.placename" content="Montreal" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_CA" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
}
